<template>
  <iColumn gap="small" width="fill">
    <iRow
      v-for="(story, idx) in placeholderStories"
      :key="idx"
      gap="small"
      width="fill"
      :style-overrides="{
        paddingTop: 'small',
        paddingBottom: 'small',
        paddingLeft: 'small',
        paddingRight: 'small',
        borderRadius: 'standard',
        backgroundColor: '#f4f5f7',
      }"
    >
      <iColumn gap="extraSmall" width="fill">
        <iText font-weight="strong">
          {{ story.title }}
        </iText>
        <iText variant="subtle" font-size="small">
          {{ story.snippet }}
        </iText>
      </iColumn>
    </iRow>
  </iColumn>
</template>

<script>
// SmartFeedV2 + smart-feed-engine live outside the editor directory
// tree. Canvas preview renders a static list off example data so the
// element stays inside the editor boundary.
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";

export default {
  name: "StoriesWithHashtag",
  mixins: [
    DynamicElementMixin,
  ],
  elementPanelSettings: {
    displayName: "Stories with Hashtag",
    displayIcon: "feed",
    elementGroup: "storiesWithHashtagElements",
    elementType: "element",
  },
  options: [
    new LayoutWidth({
      "default": "fill",
      "hover": "fill",
    }, true),
    new EmptyStateText({ "default": "There are no stories with this hashtag." }),
  ],
  computed: {
    placeholderStories() {
      return [
        { title: "Sustainable wardrobe tips", snippet: "Building a closet that lasts longer." },
        { title: "Five minimalist looks", snippet: "Pieces I wear on repeat." },
      ];
    },
  },
};
</script>
